export const switchLoading =
  <LType extends string>(loadingState: boolean, loadingFieldName: LType) =>
  <State extends { [key in LType]: boolean }>(state: State): State => ({
    ...state,
    [loadingFieldName]: loadingState
  });

export const switchLoadingDefault = (loadingState: boolean) =>
  switchLoading(loadingState, 'isLoading');
